import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { socialMediasConfig } from '../../home/contact/social-medias'
import { Image } from '../style/components/image'
import { NewTabLink } from '../style/components/links'
import { mobile } from '../style/media-queries'

export const SocialMedias = () => {
  const [t] = useTranslation('social_medias')

  return (
    <Wrapper>
      {socialMediasConfig.map(media => (
        <IconLink
          key={media.name}
          to={t(media.name)}
          eventLabel={media.gaLabel}
        >
          <Image src={media.srcCTA} alt={media.name} />
        </IconLink>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  top: 100px;
  right: 0;
  display: flex;
  flex-direction: column;
  z-index: 15;

  @media ${mobile} {
    display: none;
  }
`

const IconLink = styled(NewTabLink)`
  margin-bottom: 10px;
  transform: translateX(10px);
  transition-property: transform;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;

  &:hover {
    transform: translateX(0px);
  }
`
